<template>
    <div class="mbody">
        <div class="settholder">
            <div style="text-align: center;font-size: 17pt;">Track</div>

            <div style="text-align: center;;"> <img style="width: 80px;height: 80px;" src="../../assets/underconst.png">
            </div>

            <hr style="width: 90%;">

            <span><span>#NFT ID: </span><input v-model="filt_comp" type="text"
                    placeholder="leave empty for full log" /></span>


            <div class="wolder">
                <table>

                    <tr class="wstreng" v-for="mele, meleidx in filtered" :key="meleidx">
                        <td v-if="mele.has(0)">#{{ mele.data.params[0] }}</td>
                        <td v-if="mele.has(1)"> {{ mele.data.name.indexOf('STRENG') > -1 ? 'strengthened' : 'stolen' }}
                        </td>
                        <td v-if="mele.has(2)">
                            {{ mele.data.params[1].int }}
                        </td>
                        <td v-if="mele.has(3)">&rarr;</td>
                        <td v-if="mele.has(4)">
                            {{ mele.data.params[2].int }}
                        </td>
                        <td v-if="mele.has(5)"></td>
                        <td v-if="mele.has(6)">{{ mele.data.blockTime.split(".")[0].split("T").join(" ") }}</td>

                    </tr>
                </table>
                <div style="margin-top: 2%;align-self: center;justify-self: center;">

                    <button @click="hlod()">
                        <LoadingComp v-if="misloading"></LoadingComp>
                        <div v-if="!misloading">load <span v-if="teloded.length > 0">more</span></div>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import ENUMS from '../Enums';
// import Pact from 'pact-lang-api'
import { get_wallet_manager } from '@/utility'
import LoadingComp from '../LoadingComp.vue';

class TrackItem {
    data;
    constructor(ele) {
        this.data = ele
    }
    has(x) {
        if (x > 1 && this.data.name.indexOf("STOLEN")>-1) return false
        return true
    }
}

export default {
    name: ENUMS.VIEWS.TRACK,
    methods: {
        hlod() {
            this.misloading = true
            var qthis = this;
            get_wallet_manager(this).then(() => {
                fetch("https://estats.chainweb.com/txs/events?search=free.coal.NFT_S&offset=" + qthis.moffset + "&limit=" + qthis.mlim, {
                    "headers": {
                        "accept": "*/*",
                        "accept-language": "en-US,en;q=0.5",
                        "sec-ch-ua": "\"Not?A_Brand\";v=\"8\", \"Chromium\";v=\"108\", \"Brave\";v=\"108\"",
                        "sec-ch-ua-mobile": "?0",
                        "sec-ch-ua-platform": "\"Linux\"",
                        "sec-fetch-dest": "empty",
                        "sec-fetch-mode": "cors",
                        "sec-fetch-site": "cross-site",
                        "sec-gpc": "1"
                    },
                    "referrerPolicy": "strict-origin-when-cross-origin",
                    "body": null,
                    "method": "GET",
                    "credentials": "omit"
                }).then(x => x.text()).then(x => {
                    x = JSON.parse(x);
                    console.log(x);
                    qthis.teloded_comp = qthis.teloded.concat(x.map(x => new TrackItem(x)))
                    qthis.moffset += qthis.mlim
                    // for (var i in x) {
                    //     var tmp = x[i];
                    //     console.log(tmp.params);
                    // }
                }).finally(() => {
                    qthis.misloading = false
                });
                // Pact.event.range("13", 3327529, 3327529 + 10, vget(wal, "network_id"), wal.get_api_host())
                // Pact.event.recent("13", 100, 100, vget(wal, "network_id"), wal.get_api_host()).then(x => {
                //     console.log(x)
                // })
            });
        }, apply_filter(flt) {
            if (flt == "") {
                this.filtered = this.teloded
            } else {
                this.filtered = this.teloded.filter(x => ((x.data.name.indexOf("STRENG") > -1) || (x.data.name.indexOf("STOLEN") > -1)) && (x.data.params[0] == flt))
                console.log(this.filtered)
            }
        }
    }, computed: {
        filt_comp: {
            set(flt) {
                this.filt = flt
                this.apply_filter(flt)

            }, get() {
                return this.filt
            }
        }, teloded_comp: {
            set(x) {
                this.teloded = x
                this.apply_filter(this.filt)

            }, get() {
                return this.teloded
            }
        }
    }
    ,
    data() {
        return {
            moffset: 0,
            mlim: 20,
            misloading: false,
            teloded: [],
            filt: "",
            filtered: [],
            ENUMS: ENUMS
        };
    },
    components: { LoadingComp }
}

</script>

<style scoped>
input {
    color: black;
    text-align: center;
}

.wolder {
    background-color: rgb(44, 44, 44);
    min-height: 500px;
    width: 100%;
    display: flex;

    flex-direction: column;

    justify-content: center;
    align-items: center;

    /* display: grid;
    justify-content: center;
    grid-template-columns: 5;
    column-gap: 2%; */
}

.wstreng {
    align-self: flex-start;
    justify-self: start;
}

.settholder {
    display: flex;
    flex-direction: column;
    padding-left: 10%;
    padding-right: 10%;
    row-gap: 20px;
    border-style: solid;
    border-color: white;
    padding: 10%;
    padding-top: 2%;
    padding-bottom: 2%;
}

td {
    text-align: center;
    justify-content: center;
}
</style>